<template>
  <div v-if="sidebarOpen" class="sidebar-overlay" @click="closeSidebar"></div>
  <aside class="sidebar" :class="{ 'sidebar-open': sidebarOpen }">
    <div class="logo-area">
      <div class="logo-mark">Z</div>
      <span>智磐 AI</span>
    </div>

    <div class="nav-menu">
      <div class="nav-group-title">工作区</div>
      <div
        class="nav-item"
        :class="{ active: isActive('upload') }"
        @click="goAndClose('/upload')"
      >
        <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
          <polyline points="17 8 12 3 7 8"></polyline>
          <line x1="12" y1="3" x2="12" y2="15"></line>
        </svg>
        产品上传
      </div>
      <div
        class="nav-item nav-parent"
        :class="{ active: isImageGenActive, expanded: imageGenExpanded }"
        @click="toggleImageGen"
      >
        <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
          <circle cx="8.5" cy="8.5" r="1.5"></circle>
          <polyline points="21 15 16 10 5 21"></polyline>
        </svg>
        图片生成
        <svg class="nav-arrow" :class="{ rotated: imageGenExpanded }" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="14" height="14">
          <polyline points="6 9 12 15 18 9"></polyline>
        </svg>
      </div>
      <div v-if="imageGenExpanded" class="nav-sub">
        <div class="nav-sub-item" :class="{ active: isActive('imageGen') && workbench.imageGen.step === 2 }" @click="goImageGen(2)">宣传图</div>
        <div class="nav-sub-item" :class="{ active: isActive('imageGen') && workbench.imageGen.step === 3 }" @click="goImageGen(3)">裂变图</div>
        <div class="nav-sub-item" :class="{ active: isActive('imageGen') && workbench.imageGen.step === 4 }" @click="goImageGen(4)">主图</div>
      </div>
      <div
        class="nav-item"
        :class="{ active: isActive('copywriting') }"
        @click="goAndClose('/copywriting')"
      >
        <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
          <polyline points="14 2 14 8 20 8"></polyline>
          <line x1="16" y1="13" x2="8" y2="13"></line>
          <line x1="16" y1="17" x2="8" y2="17"></line>
        </svg>
        文案生成
      </div>
      <div
        class="nav-item"
        :class="{ active: isActive('sizeChart') }"
        @click="goAndClose('/size-chart')"
      >
        <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M21 21H3V3"></path>
          <path d="M21 9L15 15L11 11L3 19"></path>
        </svg>
        尺码转换
      </div>

      <!-- 暂时隐藏：宣传视频生成 -->
    </div>
  </aside>
</template>

<script setup>
import { ref, computed, inject } from "vue";
import { useRouter, useRoute } from "vue-router";
import { useNavStore } from "@/stores/useNavStore";
import { useWorkbenchStore } from "@/stores/useWorkbenchStore";

const navStore = useNavStore();
const router = useRouter();
const route = useRoute();
const workbench = useWorkbenchStore();

const sidebarOpen = inject("sidebarOpen");
const closeSidebar = inject("closeSidebar");

const imageGenExpanded = ref(true);

const isActive = (key) => navStore.activeNav === key;
const isImageGenActive = computed(() => isActive('imageGen'));

const toggleImageGen = () => {
  imageGenExpanded.value = !imageGenExpanded.value;
  if (route.path !== '/image-gen') {
    workbench.imageGen.step = 2;
    router.push('/image-gen');
    closeSidebar();
  }
};

const goImageGen = (step) => {
  workbench.imageGen.step = step;
  if (route.path !== '/image-gen') {
    router.push('/image-gen');
  }
  closeSidebar();
};

const goAndClose = (path) => {
  router.push(path);
  closeSidebar();
};
</script>

<style scoped>
.nav-parent {
  justify-content: flex-start;
  gap: 0.5rem;
}
.nav-parent .nav-arrow {
  margin-left: auto;
  transition: transform 0.2s;
}
.nav-parent .nav-arrow.rotated {
  transform: rotate(180deg);
}
.nav-sub {
  padding-left: 2.5rem;
}
.nav-sub-item {
  padding: 0.45rem 0.75rem;
  font-size: 0.88rem;
  color: var(--text-secondary, #86909c);
  cursor: pointer;
  border-radius: 6px;
  transition: background 0.15s, color 0.15s;
}
.nav-sub-item:hover {
  background: var(--warm-100, #f7f6f3);
  color: var(--text-primary, #1d2129);
}
.nav-sub-item.active {
  color: #165dff;
  background: rgba(22, 93, 255, 0.06);
  font-weight: 500;
}
</style>
